export default __webpack_public_path__ + "media/images/fonts/materialdesignicons-webfont-489a5d51dc8059afea165fe93f5b48e5.woff";